var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherTokensIconShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_1073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4032 7.9319C24.3685 7.16371 24.3685 6.43042 24.3685 5.69714C24.3685 5.10353 23.9172 4.6496 23.327 4.6496C18.9873 4.6496 15.6892 3.39254 12.9465 0.703846C12.5299 0.319747 11.9051 0.319747 11.4885 0.703846C8.74581 3.39254 5.44765 4.6496 1.108 4.6496C0.517806 4.6496 0.0664819 5.10353 0.0664819 5.69714C0.0664819 6.43042 0.0664819 7.16371 0.0317647 7.9319C-0.107104 15.2647 -0.315408 25.3211 11.8703 29.5462L12.2175 29.6161L12.5647 29.5462C24.7157 25.3211 24.5421 15.2996 24.4032 7.9319ZM11.3843 18.0931C11.176 18.2677 10.933 18.3725 10.6552 18.3725H10.6205C10.3427 18.3725 10.065 18.2328 9.89145 18.0232L6.66275 14.4266L8.225 13.0299L10.7594 15.8583L16.3835 10.4809L17.8069 12.0173L11.3843 18.0931Z",
    fill: "url(#paint0_linear_414_1073)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_414_1073",
    x1: -2.12923,
    y1: 10.2005,
    x2: 25.1237,
    y2: 11.2227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ADF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A5F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_1073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTokensIconShield);
export default __webpack_public_path__ + "static/media/other-tokens-icon-shield.05fcd35e013e6a995ea710817124a0c5.svg";
export { ForwardRef as ReactComponent };